export default __webpack_public_path__ + "static/media/icon-shopee.c5260252.webp";